<template>
    <!-- Dialog showing change history of overtime requests -->
    <v-dialog v-model="dialog" max-width="1200px" scrollable>
        <v-card class="rounded-xl">
            <!-- Title Bar -->
            <v-card-title class="text-h6 font-weight-bold py-4 px-6 d-flex align-center">
                <v-icon color="teal darken-4" class="mr-2">mdi-history</v-icon>
                Lịch sử tác động phiếu làm thêm
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <!-- Search and Table Container -->
            <v-card-text class="px-6 py-4">
                <!-- Search input for filtering history logs -->
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Tìm kiếm nhanh..."
                    single-line
                    hide-details
                    outlined
                    dense
                    color="teal darken-4"
                    class="mb-4 bg-white rounded-lg"
                ></v-text-field>

                <!-- Data table for log history -->
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :loading="isLoading"
                    loading-text="Đang tải dữ liệu lịch sử..."
                    no-data-text="Không có lịch sử tác động nào."
                    class="elevation-1 rounded-lg"
                    :footer-props="{
                        itemsPerPageText: 'Số dòng mỗi trang:',
                        itemsPerPageOptions: [10, 20, 50, 100]
                    }"
                >
                    <!-- Format CreatedAt Column -->
                    <template v-slot:[`item.createdAt`]="{ item }">
                        <span>{{ formatDateTime(item.createdAt) }}</span>
                    </template>

                    <!-- Format Creator (Name + Code) -->
                    <template v-slot:[`item.creator`]="{ item }">
                        <div class="font-weight-medium">{{ item.createdByName }}</div>
                        <div class="caption grey--text">{{ item.createdBy }}</div>
                    </template>

                    <!-- Format Action Type -->
                    <template v-slot:[`item.action`]="{ item }">
                        <v-chip small color="teal lighten-5" text-color="teal darken-4" class="font-weight-bold">
                            {{ item.action }}
                        </v-chip>
                    </template>

                    <!-- Format ShortData with tooltip for long text -->
                    <template v-slot:[`item.shortData`]="{ item }">
                        <div class="text-truncate" style="max-width: 250px;" :title="item.shortData">
                            {{ item.shortData }}
                        </div>
                    </template>

                    <!-- Format Note with tooltip for long text -->
                    <template v-slot:[`item.note`]="{ item }">
                        <div class="text-truncate grey--text text--darken-2 text-caption" style="max-width: 250px;" :title="item.note">
                            {{ item.note }}
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import http from '@/components/services/http-common';
import * as moment from "moment/moment";

export default {
    name: "OvertimeHistoryDialog",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // Two-way dialog visibility state binding
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    watch: {
        // Fetch logs when dialog is opened
        value(val) {
            if (val) {
                this.fetchHistory();
            }
        }
    },
    data() {
        return {
            isLoading: false,
            search: "",
            items: [],
            // Data table columns mapping
            headers: [
                { text: 'Thời gian', value: 'createdAt', width: '160px', sortable: true },
                { text: 'Người thực hiện', value: 'creator', width: '180px', sortable: true },
                { text: 'Hành động', value: 'action', width: '120px', sortable: true },
                { text: 'Mã phiếu', value: 'targetCode', width: '130px', sortable: true },
                { text: 'Đối tượng', value: 'resource', width: '130px', sortable: true },
                { text: 'Liên quan', value: 'belongTo', width: '120px', sortable: true },
                { text: 'Thông tin nhanh', value: 'shortData', sortable: false },
                { text: 'Ghi chú', value: 'note', sortable: false },
            ]
        };
    },
    methods: {
        // Format log timestamp
        formatDateTime(value) {
            if (!value) return "";
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        // Fetch action logs from overtimeRequests/history
        fetchHistory() {
            this.isLoading = true;
            http.get("overtimeRequests/history")
                .then(res => {
                    const data = res.data;
                    if (data && data.results) {
                        this.items = data.results;
                    } else if (data && data.data) {
                        this.items = data.data;
                    } else if (Array.isArray(data)) {
                        this.items = data;
                    } else {
                        this.items = [];
                    }
                })
                .catch(err => {
                    console.error("Lỗi khi tải lịch sử:", err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>

<style scoped>
.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
